import script from "./outbound.vue?vue&type=script&setup=true&lang=ts"
export * from "./outbound.vue?vue&type=script&setup=true&lang=ts"

import "./outbound.vue?vue&type=style&index=0&id=1829e3fc&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1829e3fc"]])

export default __exports__